import * as THREE from 'three'
import { toast } from 'react-toastify';

// working not fine.....
function loft(oc, points0, points1) {
  // PointsToBSpline関数を使用して、滑らかな曲線を作成する
  const tolerance = 0.001;
  const degree = 3;
  const weights = null;
  const knots = null;
  const periodic = true;

  
  const points0oc = new oc.TColgp_Array1OfPnt_2(1, 4);
  points0oc.SetValue(1, new oc.gp_Pnt_3(0, 0, 0));
  points0oc.SetValue(2, new oc.gp_Pnt_3(100, 0, 100));
  points0oc.SetValue(3, new oc.gp_Pnt_3(100, 0, 50));
  points0oc.SetValue(4, new oc.gp_Pnt_3(0.1, 0, 0));

  const points1oc = new oc.TColgp_Array1OfPnt_2(1, 3);
  points1oc.SetValue(1, new oc.gp_Pnt_3(0, 200, 0));
  points1oc.SetValue(2, new oc.gp_Pnt_3(100, 200, 100));
  points1oc.SetValue(3, new oc.gp_Pnt_3(100, 200, 50));
  //points0oc.SetValue(4, new oc.gp_Pnt_3(0.1, 200, 0));
  

  /*
  const points0oc = new oc.TColgp_Array1OfPnt_2(1, 4);
  points0oc.SetValue(1, new oc.gp_Pnt_3(30, 0, 0));
  points0oc.SetValue(2, new oc.gp_Pnt_3(0, 30, 0));
  points0oc.SetValue(3, new oc.gp_Pnt_3(-30, 0, 0));
  //points0oc.SetValue(3, new oc.gp_Pnt_3(0, -30, 0));

  const points1oc = new oc.TColgp_Array1OfPnt_2(1, 4);
  points0oc.SetValue(1, new oc.gp_Pnt_3(30, 0, 100));
  points0oc.SetValue(2, new oc.gp_Pnt_3(0, 30, 100));
  points0oc.SetValue(3, new oc.gp_Pnt_3(-30, 0, 100));
  //points0oc.SetValue(3, new oc.gp_Pnt_3(0, -30, 100));
  */
  
  /*
  const points0oc = new oc.TColgp_Array1OfPnt_2(1, points0.length);
  for (let i = 0; i < points0.length; i+) {
    points0oc.SetValue(i+1, new oc.gp_Pnt_3(points0[i].x, points0[i].y, points0[i].z));
  }
  const points1oc = new oc.TColgp_Array1OfPnt_2(1, points1.length);
  for (let i = 0; i < points0.length; i++) {
    points1oc.SetValue(i+1, new oc.gp_Pnt_3(points1[i].x, points1[i].y, points1[i].z));
  }
  */


  /*
  // https://codemonkey.link/donalffons/opencascade.js-examples/issues/12
  const splineCurve0 = new oc.GeomAPI_PointsToBSpline_2(points0oc, degree, degree, periodic, tolerance);
  const handleCurve0 = new oc.Handle_Geom_Curve_2(splineCurve0.Curve().get());
  const edge0 = new oc.BRepBuilderAPI_MakeEdge_24(handleCurve0).Edge();
  const wire0 = new oc.BRepBuilderAPI_MakeWire_2(edge0).Wire();

  const splineCurve1 = new oc.GeomAPI_PointsToBSpline_2(points1oc, degree, degree, periodic, tolerance);
  const handleCurve1 = new oc.Handle_Geom_Curve_2(splineCurve1.Curve().get());
  const edge1 = new oc.BRepBuilderAPI_MakeEdge_24(handleCurve1).Edge();
  const wire1 = new oc.BRepBuilderAPI_MakeWire_2(edge1).Wire();
  */
  
  const profileCircle0 = new oc.gp_Circ_2(new oc.gp_Ax2_3(new oc.gp_Pnt_3(-100, 0, 0), new oc.gp_Dir_4(0, 0, 1)), 40);
  const edge0 = new oc.BRepBuilderAPI_MakeEdge_8(profileCircle0).Edge();
  const wire0 = new oc.BRepBuilderAPI_MakeWire_2(edge0).Wire();

  console.log(wire0)

  const profileCircle1 = new oc.gp_Circ_2(new oc.gp_Ax2_3(new oc.gp_Pnt_3(-50, 0, 0), new oc.gp_Dir_4(0, 0, 1)), 100);
  const edge1 = new oc.BRepBuilderAPI_MakeEdge_8(profileCircle1).Edge();
  const wire1 = new oc.BRepBuilderAPI_MakeWire_2(edge1).Wire();

  console.log(wire1)
  

  const loft = new oc.BRepOffsetAPI_ThruSections(false, true, 1e-4);
  loft.AddWire(wire0);
  loft.AddWire(wire1);
  try {
    loft.Build(new oc.Message_ProgressRange_1());
  } catch (e) {
    console.log(e);
    toast.error('Loft failed');
    return null;
  }
  const result = loft.Shape();

  return result;
}

export function sweepOneProfileCurveAlongTwoTraceCurves(oc, profilePoints, guideCurve0Points, guideCurve1Points) {
  // １つ目の断面プロファイルを定義
  const curvePointArray = new oc.TColgp_Array1OfPnt_2(1, profilePoints.length);
  for (let i = 0; i < profilePoints.length; i++) {
    curvePointArray.SetValue(i+1, new oc.gp_Pnt_3(...profilePoints[i]));
  }

  // PointsToBSpline関数を使用して、滑らかな曲線を作成する
  const tolerance = 0.001;
  const degree = 3;
  const weights = null;
  const knots = null;
  const periodic = false;
  const splineCurve = new oc.GeomAPI_PointsToBSpline_2(curvePointArray, degree, degree, periodic, tolerance);
  
  // https://codemonkey.link/donalffons/opencascade.js-examples/issues/12
  const handleCurve = new oc.Handle_Geom_Curve_2(splineCurve.Curve().get());

  const edge1 = new oc.BRepBuilderAPI_MakeEdge_24(handleCurve).Edge();
  const wire1 = new oc.BRepBuilderAPI_MakeWire_2(edge1).Wire();



  // １つ目のガイドカーブを定義
  const tracePointArray = new oc.TColgp_Array1OfPnt_2(1, guideCurve0Points.length);
  for (let i = 0; i < guideCurve0Points.length; i++) {
    tracePointArray.SetValue(i+1, new oc.gp_Pnt_3(...guideCurve0Points[i]));
  }

  // PointsToBSpline関数を使用して、滑らかな曲線を作成する
  const traceCurve = new oc.GeomAPI_PointsToBSpline_2(tracePointArray, degree, degree, periodic, tolerance);
  
  // https://codemonkey.link/donalffons/opencascade.js-examples/issues/12
  const traceHandleCurve1 = new oc.Handle_Geom_Curve_2(traceCurve.Curve().get());

  const traceEdge1 = new oc.BRepBuilderAPI_MakeEdge_24(traceHandleCurve1).Edge();
  const traceWire1 = new oc.BRepBuilderAPI_MakeWire_2(traceEdge1).Wire();


  // ２つ目のガイドカーブを定義
  const trace2PointArray = new oc.TColgp_Array1OfPnt_2(1, guideCurve1Points.length);
  for (let i = 0; i < guideCurve1Points.length; i++) {
    trace2PointArray.SetValue(i+1, new oc.gp_Pnt_3(...guideCurve1Points[i]));
  }

  // PointsToBSpline関数を使用して、滑らかな曲線を作成する
  const traceCurve2 = new oc.GeomAPI_PointsToBSpline_2(trace2PointArray, degree, degree, periodic, tolerance);
  
  // https://codemonkey.link/donalffons/opencascade.js-examples/issues/12
  const traceHandleCurve2 = new oc.Handle_Geom_Curve_2(traceCurve2.Curve().get());

  const traceEdge2 = new oc.BRepBuilderAPI_MakeEdge_24(traceHandleCurve2).Edge();
  const traceWire2 = new oc.BRepBuilderAPI_MakeWire_2(traceEdge2).Wire();
  
  // スイープの初期化
  var sweepBuilder = new oc.BRepOffsetAPI_MakePipeShell(wire1);
  // 1つ目のガイドカーブを追加
  sweepBuilder.Add_1(
    traceWire1,
    false,
    false,
  );

  // 2つ目のガイドカーブを追加
  sweepBuilder.Add_1(
    traceWire2,
    false,
    false,
  );
  
  // 断面プロファイルカーブを追加
  //sweepBuilder.SetMode_5(traceWire, false, true);
  sweepBuilder.SetMode_1(false);

  // スイープ操作の実行
  try {
    sweepBuilder.Build(new oc.Message_ProgressRange_1());
  } catch (e) {
    console.log(e);
    toast.error('Fail to sweep, please change the parameters.')
    return null;
  }
  // 結果の取得
  const resultShape = sweepBuilder.Shape();
  
  splineCurve.delete();
  handleCurve.delete();
  edge1.delete();
  wire1.delete();
  tracePointArray.delete();
  traceCurve.delete();
  traceHandleCurve1.delete();
  traceEdge1.delete();
  traceWire1.delete();
  trace2PointArray.delete();
  traceCurve2.delete();
  traceHandleCurve2.delete();
  traceEdge2.delete();
  traceWire2.delete();
  sweepBuilder.delete();
  
  return resultShape;
}



export function points2surface(oc, points) {
  const builder = new oc.BRep_Builder();
  const aComp = new oc.TopoDS_Compound();
  builder.MakeCompound(aComp);

  var crossSectionPoly = new oc.BRepBuilderAPI_MakePolygon_1();
  const crossSectionPts = points;
  crossSectionPoly = new oc.BRepBuilderAPI_MakePolygon_1();
  crossSectionPts.forEach((p) => crossSectionPoly.Add_1(new oc.gp_Pnt_3(p.x, p.y, p.z)));
  crossSectionPoly.Close();
  const crossSectionWire = crossSectionPoly.Wire();
  const f = new oc.BRepBuilderAPI_MakeFace_15(crossSectionWire, false);

  builder.Add(aComp, f.Shape())

  return aComp;
}

export function testLoft(oc) {
  // プロファイルカーブ1を定義
  const profile1Pts = [
    new oc.gp_Pnt_3(0, 0, 0),
    new oc.gp_Pnt_3(10, 0, 0),
    new oc.gp_Pnt_3(10, 10, 0),
    new oc.gp_Pnt_3(0, 10, 0)
  ];

  const profile1Poly = new oc.BRepBuilderAPI_MakePolygon_1();
  profile1Pts.forEach((p) => profile1Poly.Add_1(p));
  profile1Poly.Close();
  const profile1Wire = profile1Poly.Wire();

  // プロファイルカーブ2を定義
  const profile2Pts = [
    new oc.gp_Pnt_3(0, 0, 10),
    new oc.gp_Pnt_3(5, 0, 10),
    new oc.gp_Pnt_3(5, 5, 10),
    new oc.gp_Pnt_3(0, 5, 10)
  ];

  const profile2Poly = new oc.BRepBuilderAPI_MakePolygon_1();
  profile2Pts.forEach((p) => profile2Poly.Add_1(p));
  profile2Poly.Close();
  const profile2Wire = profile2Poly.Wire();

  // Loft機能を使用してサーフェスを生成
  const loft = new oc.BRepOffsetAPI_ThruSections(false, false, 1e-6);
  loft.AddWire(profile1Wire);
  loft.AddWire(profile2Wire);
  loft.Build(new oc.Message_ProgressRange_1());
  const result = loft.Shape();

  return result;
}

/*
export function testLoft2(oc) {
  const loft = new oc.BRepOffsetAPI_ThruSections(false, false, 1e-6);
  // 1つ目の閉曲線 (円) を定義
  const circle1 = new oc.gp_Circ(new oc.gp_Ax2(new oc.gp_Pnt(0, 0, 0), new oc.gp_Dir(0, 0, 1)), 5);
  const edge1 = new oc.BRepBuilderAPI_MakeEdge(circle1).Edge();
  const wire1 = new oc.BRepBuilderAPI_MakeWire(edge1).Wire();

  // 2つ目の閉曲線 (円) を定義
  const circle2 = new oc.gp_Circ(new oc.gp_Ax2(new oc.gp_Pnt(0, 0, 10), new oc.gp_Dir(0, 0, 1)), 3);
  const edge2 = new oc.BRepBuilderAPI_MakeEdge(circle2).Edge();
  const wire2 = new oc.BRepBuilderAPI_MakeWire(edge2).Wire();


  // Loft機能を使用してサーフェスを生成
  loft.AddWire(wire1);
  loft.AddWire(wire2);
  loft.Build(new oc.Message_ProgressRange_1());
  const result = loft.Shape();

  return result;
}
*/





export function visualize(openCascade, shape) {
  let geometries = []
  const ExpFace = new openCascade.TopExp_Explorer_1();
  for (ExpFace.Init(shape, openCascade.TopAbs_ShapeEnum.TopAbs_FACE, openCascade.TopAbs_ShapeEnum.TopAbs_SHAPE); ExpFace.More(); ExpFace.Next()) {
    const myShape = ExpFace.Current();
    const myFace = openCascade.TopoDS.Face_1(myShape);
    let inc;
    try {
      //in case some of the faces can not been visualized
      inc = new openCascade.BRepMesh_IncrementalMesh_2(myFace, 0.1, false, 0.5, false);
    } catch (e) {
      console.error('face visualizi<ng failed');
      continue;
    }

    const aLocation = new openCascade.TopLoc_Location_1();
    const myT = openCascade.BRep_Tool.Triangulation(myFace, aLocation, 0 /* == Poly_MeshPurpose_NONE */);
    if (myT.IsNull()) {
      continue;
    }

    const pc = new openCascade.Poly_Connect_2(myT);
    const triangulation = myT.get();

    let vertices = new Float32Array(triangulation.NbNodes() * 3);

    // write vertex buffer
    for (let i = 1; i <= triangulation.NbNodes(); i++) {
      const t1 = aLocation.Transformation();
      const p = triangulation.Node(i);
      const p1 = p.Transformed(t1);
      vertices[3 * (i - 1)] = p1.X();
      vertices[3 * (i - 1) + 1] = p1.Y();
      vertices[3 * (i - 1) + 2] = p1.Z();
      p.delete();
      t1.delete();
      p1.delete();
    }

    // write normal buffer
    const myNormal = new openCascade.TColgp_Array1OfDir_2(1, triangulation.NbNodes());
    openCascade.StdPrs_ToolTriangulatedShape.Normal(myFace, pc, myNormal);

    let normals = new Float32Array(myNormal.Length() * 3);
    for (let i = myNormal.Lower(); i <= myNormal.Upper(); i++) {
      const t1 = aLocation.Transformation();
      const d1 = myNormal.Value(i);
      const d = d1.Transformed(t1);

      normals[3 * (i - 1)] = d.X();
      normals[3 * (i - 1) + 1] = d.Y();
      normals[3 * (i - 1) + 2] = d.Z();

      t1.delete();
      d1.delete();
      d.delete();
    }

    myNormal.delete();

    // write triangle buffer
    const orient = myFace.Orientation_1();
    const triangles = myT.get().Triangles();
    let indices;
    let triLength = triangles.Length() * 3;
    if (triLength > 65535)
      indices = new Uint32Array(triLength);
    else
      indices = new Uint16Array(triLength);

    for (let nt = 1; nt <= myT.get().NbTriangles(); nt++) {
      const t = triangles.Value(nt);
      let n1 = t.Value(1);
      let n2 = t.Value(2);
      let n3 = t.Value(3);
      if (orient !== openCascade.TopAbs_Orientation.TopAbs_FORWARD) {
        let tmp = n1;
        n1 = n2;
        n2 = tmp;
      }

      indices[3 * (nt - 1)] = n1 - 1;
      indices[3 * (nt - 1) + 1] = n2 - 1;
      indices[3 * (nt - 1) + 2] = n3 - 1;
      t.delete();
    }
    triangles.delete();

    let geometry = new THREE.BufferGeometry();
    geometry.setAttribute('position', new THREE.BufferAttribute(vertices, 3));
    geometry.setAttribute('normal', new THREE.BufferAttribute(normals, 3));

    geometry.setIndex(new THREE.BufferAttribute(indices, 1));
    geometries.push(geometry);

    pc.delete();
    aLocation.delete();
    myT.delete();
    inc.delete();
    myFace.delete();
    myShape.delete();
  }
  ExpFace.delete();
  
  return geometries;
}

export function makeCutObjectSi(oc, points, offset=400) {
  const extrusionHeight = 400;

  const tolerance = 0.001;
  const degree = 3;
  const weights = null;
  const knots = null;
  const periodic = false;

  const tempFirst = points[0];
  const tempLast = points[points.length-1];
  
  const addPoints = [
    new THREE.Vector3(tempLast.x, tempLast.y, tempLast.z-offset),
    new THREE.Vector3(tempFirst.x-offset, tempFirst.y, tempLast.z-offset),
    new THREE.Vector3(tempFirst.x-offset, tempFirst.y, tempFirst.z+offset),
    new THREE.Vector3(tempFirst.x, tempFirst.y, tempFirst.z+offset),
    tempFirst
  ];

  const trimPoints = points.concat(addPoints)

  try {
    const pointsSequence = new oc.TColgp_Array1OfPnt_2(1, trimPoints.length);
    
    trimPoints.forEach((point, i) => {
      pointsSequence.SetValue(i+1, new oc.gp_Pnt_3(point.x, point.y, point.z));
    });
    
    // make spline wire
    //const splineCurve0 = new oc.GeomAPI_PointsToBSpline_2(pointsSequence, degree, degree, periodic, tolerance);
    //const handleCurve0 = new oc.Handle_Geom_Curve_2(splineCurve0.Curve().get());
    //const edge0 = new oc.BRepBuilderAPI_MakeEdge_24(handleCurve0).Edge();
    //const wire0 = new oc.BRepBuilderAPI_MakeWire_2(edge0).Wire();

    // make polygon wire
    const profile1Poly = new oc.BRepBuilderAPI_MakePolygon_1();
    trimPoints.forEach((p) => profile1Poly.Add_1(new oc.gp_Pnt_3(p.x, p.y, p.z)));
    const wire0 = profile1Poly.Wire();

    // make surface
    const faceBuilder = new oc.BRepBuilderAPI_MakeFace_15(wire0, true);
    faceBuilder.Build(new oc.Message_ProgressRange_1())
    const face = faceBuilder.Face();

    // make solid with extrude
    const extrusionDir = new oc.gp_Vec_4(0, extrusionHeight, 0);
    let solid = new oc.BRepPrimAPI_MakePrism_1(face, extrusionDir, false, true);
    let shapeSolid = solid.Shape();
    
    // move solid
    const translationVec= new oc.gp_Vec_4(0, -extrusionHeight/2, 0);
    const aTrsf = new oc.gp_Trsf_1();
    aTrsf.SetTranslation_1(translationVec);
    const shapeSolidTrsf = new oc.BRepBuilderAPI_Transform_2(shapeSolid, aTrsf, false);

    // delete oc objects
    pointsSequence.delete();
    //splineCurve0.delete();
    faceBuilder.delete();
    face.delete();
    translationVec.delete()
    aTrsf.delete()
    
    return {
      shape: shapeSolidTrsf.Shape(),
      points: trimPoints
    };

  } catch (e) {
    console.log(e)
  }

  return null
}

/* // shepaをextrudeするのはうまくいかない
export function makeCutObjectMl(oc, points, offset=100) {

  const extrusionHeight = 400;

  const tolerance = 0.001;
  const degree = 3;
  const weights = null;
  const knots = null;
  const periodic = false;
  

  try {
    const pointsSequence = new oc.TColgp_Array1OfPnt_2(1, points.length);
    
    points.forEach((point, i) => {
      pointsSequence.SetValue(i+1, new oc.gp_Pnt_3(point.x, point.y, point.z));
    });
    
    // make spline wire
    const splineCurve0 = new oc.GeomAPI_PointsToBSpline_2(pointsSequence, degree, degree, periodic, tolerance);
    const handleCurve0 = new oc.Handle_Geom_Curve_2(splineCurve0.Curve().get());
    const edge0 = new oc.BRepBuilderAPI_MakeEdge_24(handleCurve0).Edge();
    const wire0 = new oc.BRepBuilderAPI_MakeWire_2(edge0).Wire();

    
    // make polygon wire
    //const profile1Poly = new oc.BRepBuilderAPI_MakePolygon_1();
    //trimPoints.forEach((p) => profile1Poly.Add_1(new oc.gp_Pnt_3(p.x, p.y, p.z)));
    //const wire0 = profile1Poly.Wire();
    

    // make face
    const faceBuilder = new oc.BRepBuilderAPI_MakeFace_15(wire0, true);
    faceBuilder.Build(new oc.Message_ProgressRange_1())
    const face = faceBuilder.Face();

    // make surface with extrude
    let extrusionDir = new oc.gp_Vec_4(0, extrusionHeight, 0);
    let surface = new oc.BRepPrimAPI_MakePrism_1(face, extrusionDir, false, true);
    let shapeSurface = surface.Shape();
    
    // make solid with extrude
    let extrusionDir2 = new oc.gp_Vec_4(-extrusionHeight, 0, 0);
    let solid = new oc.BRepPrimAPI_MakePrism_1(shapeSurface, extrusionDir2, false, true);
    let shapeSolid = solid.Shape();

    // move surface
    const translationVec= new oc.gp_Vec_4(0, extrusionHeight/2, 0);
    const aTrsf = new oc.gp_Trsf_1();
    aTrsf.SetTranslation_1(translationVec);
    //let shapeSurfaceTrsf = new oc.BRepBuilderAPI_Transform_2(shapeSurface, aTrsf, false);

    //console.log(shapeSurfaceTrsf.Shape().ShapeType())
    //console.log(shapeSurfaceTrsf.Shape())



    // delete oc objects
    pointsSequence.delete();
    //splineCurve0.delete();
    faceBuilder.delete();
    face.delete();
    translationVec.delete()
    aTrsf.delete()

    return shapeSolid;

  } catch (e) {
    console.log(e)
  }

  return null
}
*/

export function makeCutObjectMl(oc, points, offset=300) {

  const extrusionHeight = 400;

  const tolerance = 0.001;
  const degree = 3;
  const weights = null;
  const knots = null;
  const periodic = false;
  
  const tempFirst = points[0];
  const tempLast = points[points.length-1];
  
  const addPoints = [
    new THREE.Vector3(tempLast.x, tempLast.y, tempLast.z-offset),
    new THREE.Vector3(tempLast.x, tempLast.y+offset, tempLast.z-offset),
    new THREE.Vector3(tempFirst.x, tempFirst.y+offset, tempFirst.z+offset),
    new THREE.Vector3(tempFirst.x, tempFirst.y, tempFirst.z+offset),
    tempFirst
  ];

  const trimPoints = points.concat(addPoints)

  try {
    //const pointsSequence = new oc.TColgp_Array1OfPnt_2(1, trimPoints.length);
    
    //trimPoints.forEach((point, i) => {
    //  pointsSequence.SetValue(i+1, new oc.gp_Pnt_3(point.x, point.y, point.z));
    //});
    
    // make polygon wire
    const profile1Poly = new oc.BRepBuilderAPI_MakePolygon_1();
    trimPoints.forEach((p) => profile1Poly.Add_1(new oc.gp_Pnt_3(p.x, p.y, p.z)));
    const wire0 = profile1Poly.Wire();
    

    // make surface
    const faceBuilder = new oc.BRepBuilderAPI_MakeFace_15(wire0, true);
    faceBuilder.Build(new oc.Message_ProgressRange_1())
    const face = faceBuilder.Face();

    // make solid with extrude
    const extrusionDir = new oc.gp_Vec_4(extrusionHeight, 0, 0);
    let solid = new oc.BRepPrimAPI_MakePrism_1(face, extrusionDir, false, true);
    let shapeSolid = solid.Shape();
    
    // move solid
    const translationVec= new oc.gp_Vec_4(-extrusionHeight/2, 0, 0);
    const aTrsf = new oc.gp_Trsf_1();
    aTrsf.SetTranslation_1(translationVec);
    const shapeSolidTrsf = new oc.BRepBuilderAPI_Transform_2(shapeSolid, aTrsf, false);

    // delete oc objects
    //pointsSequence.delete();
    //splineCurve0.delete();
    faceBuilder.delete();
    face.delete();
    translationVec.delete()
    aTrsf.delete()

    return {
      shape: shapeSolidTrsf.Shape(),
      points: trimPoints
    }

  } catch (e) {
    console.log(e)
  }

  return null
}

export function makeCutObjectAp(oc, points, offset=300) {

  const extrusionHeight = 400;

  const tolerance = 0.001;
  const degree = 3;
  const weights = null;
  const knots = null;
  const periodic = false;
  
  const tempFirst = points[0];
  const tempLast = points[points.length-1];
  
  const addPoints = [
    new THREE.Vector3(tempLast.x, tempLast.y+offset, tempLast.z),
    new THREE.Vector3(tempFirst.x, tempFirst.y+offset, tempFirst.z),
    tempFirst
  ];

  const trimPoints = points.concat(addPoints)

  try {
    //const pointsSequence = new oc.TColgp_Array1OfPnt_2(1, trimPoints.length);
    
    //trimPoints.forEach((point, i) => {
    //  pointsSequence.SetValue(i+1, new oc.gp_Pnt_3(point.x, point.y, point.z));
    //});
    
    // make polygon wire
    const profile1Poly = new oc.BRepBuilderAPI_MakePolygon_1();
    trimPoints.forEach((p) => profile1Poly.Add_1(new oc.gp_Pnt_3(p.x, p.y, p.z)));
    const wire0 = profile1Poly.Wire();
    

    // make surface
    const faceBuilder = new oc.BRepBuilderAPI_MakeFace_15(wire0, true);
    faceBuilder.Build(new oc.Message_ProgressRange_1())
    const face = faceBuilder.Face();

    // make solid with extrude
    const extrusionDir = new oc.gp_Vec_4(0, 0, extrusionHeight);
    let solid = new oc.BRepPrimAPI_MakePrism_1(face, extrusionDir, false, true);
    let shapeSolid = solid.Shape();
    
    // move solid
    //const translationVec= new oc.gp_Vec_4(0, 0, -extrusionHeight/2);
    const translationVec= new oc.gp_Vec_4(0, 0, 0);
    const aTrsf = new oc.gp_Trsf_1();
    aTrsf.SetTranslation_1(translationVec);
    const shapeSolidTrsf = new oc.BRepBuilderAPI_Transform_2(shapeSolid, aTrsf, false);

    // delete oc objects
    //pointsSequence.delete();
    //splineCurve0.delete();
    faceBuilder.delete();
    face.delete();
    translationVec.delete()
    aTrsf.delete()

    return {
      shape: shapeSolidTrsf.Shape(),
      points: trimPoints
    }

  } catch (e) {
    console.log(e)
  }

  return null
}


export function cutTest (oc, shape) {
  const box = new oc.BRepPrimAPI_MakeBox_2(80, 80, 80);
  const sphere = new oc.BRepPrimAPI_MakeSphere_5(new oc.gp_Pnt_3(0.5, 0.5, 0.5), 5);
  //const cut = new oc.BRepAlgoAPI_Cut_3(box.Shape(), sphere.Shape(), new oc.Message_ProgressRange_1());
  const cut = new oc.BRepAlgoAPI_Cut_3(shape, box.Shape(), new oc.Message_ProgressRange_1());
  try {
    cut.Build(new oc.Message_ProgressRange_1());
  } catch (e) {
    return null;
  }

  return cut.Shape();
}

export function cutTwoShapes (oc, shape0, shape1) {
  const cut = new oc.BRepAlgoAPI_Cut_3(shape0, shape1, new oc.Message_ProgressRange_1());
  try {
    cut.Build(new oc.Message_ProgressRange_1());
  } catch (e) {
    return null;
  }

  return cut.Shape();
}